import LoginApi from "./LoginApi";

class V3LoginApi implements LoginApi {
  fetchCustom: (
    url: string,
    options?: any,
    token?: boolean
  ) => Promise<any>;

  constructor(
    fetchC: (
      url: string,
      options?: any,
      token?: boolean
    ) => Promise<any>
  ) {
    this.fetchCustom = fetchC;
  }

  convertAuthHashToToken = (
    authenticationHash: string,
    reservationId?: number,
    customerId?: number
  ): Promise<any> => {
    if (authenticationHash === '' || (authenticationHash.length !== 48 && authenticationHash.length !== 80)) {
      return new Promise((res, rej) => rej(`Auth hash incorrect length: ${authenticationHash.length} chars (should be 48 or 80)`));
    }

    const cIdString = customerId ? customerId.toString() : "0";
    const cId = parseInt(cIdString)

    return this.fetchCustom(
      "/login/try-authentication-hash",
      {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          reservationId: reservationId === -1 ? undefined : reservationId,
          customerId: cId,
          authenticationHash
        })
      },
      false
    );
  };

  getPIN = (phoneNumber: string, reCaptchaToken?: string) => {
    return this.fetchCustom(
      "/login/send-2fa-pin",
      {
        method: "POST",
        body: JSON.stringify({ phoneNumber, reCaptchaToken })
      },
    );
  };

  sendAutoLink = (phoneNumber: string) => {
    return this.fetchCustom(
      "/login/send-auth-email",
      {
        method: "POST",
        body: JSON.stringify({ phoneNumber })
      },
    );
  };

  tryPIN = (pin: string, phoneNumber: string) => {
    return this.fetchCustom(
      "/login/try-2fa-pin",
      {
        method: "POST",
        body: JSON.stringify({ phoneNumber, pin })
      },
    );
  };
}

export default V3LoginApi;
